var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.999,
    height: 36.999,
    viewBox: "0 0 36.999 36.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-info-circle",
    d: "M19.062.563a18.5 18.5 0 1 0 18.5 18.5 18.5 18.5 0 0 0-18.5-18.5zm0 8.205a3.133 3.133 0 1 1-3.133 3.132 3.133 3.133 0 0 1 3.133-3.132zm4.177 18.947a.9.9 0 0 1-.9.9H15.78a.9.9 0 0 1-.9-.9v-1.79a.9.9 0 0 1 .9-.9h.9v-4.769h-.9a.9.9 0 0 1-.9-.9V17.57a.9.9 0 0 1 .9-.9h4.774a.9.9 0 0 1 .9.9v7.46h.9a.9.9 0 0 1 .9.9z",
    transform: "translate(-.563 -.563)",
    style: {
      fill: "#fde48d"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.181b18d0e51fe26dc41d14c2359d27bd.svg";
export { ForwardRef as ReactComponent };